module.exports = __webpack_public_path__ + "media/images/servidorok-3abd3bb6436c58bfc6554108fd3c22bd.gif";